import { createAsyncThunk } from '@reduxjs/toolkit';
import { FreezePanesSettings } from '../models/freeze-panes-settings.model';

export interface SaveDataTableFreezePanesSettingsArguments {
    projectId: number;
    dataTableId: number;
    settings: FreezePanesSettings;
}

export const saveDataTableFreezePanesSettings = createAsyncThunk(
    'dataRequest/saveDataTableFreezePanesSettings',
    async (args: SaveDataTableFreezePanesSettingsArguments, thunkAPI: any) => {
        const axios = thunkAPI.getState().core.axios;
        await axios.put(
            `/api/dataRequestProjects/${args.projectId}/dataTables/${args.dataTableId}/FreezePanesSettings/dataTable`,
            args.settings
        );
    }
);
